{"primary":{"lighter":"#0096C7","light":"#0077B6","main":"#003768","dark":"#03045E","darker":"#001e40","contrastText":"#FFFFFF"}}